import React, { useEffect } from "react";
import "./Contact.css";
import Footer from "../Components/Navigation/Footer";
import Navigation from "../Components/Navigation/Navigation";
import ContactImage from "../Assets/Images/Banner/contact.jpg";

const ContactUs = () => {
  useEffect(() => {
    document.title = "Contact Us | Zen Homes";
  }, []);

  return (
    <div className="contactUsContainer">
      <Navigation
        linkColor="black"
        submenuColor="black"
        menuIconColor="black"
      />

      <div className="contactImageContainer">
        <img
          src={ContactImage}
          alt="Modern office building"
          className="contactImage"
        />
        <div className="overlay"></div>
        <div className="contactBox">
          <h2>Contact Us</h2>
          <p>
            Looking for expert property advice? Get in touch with our team
            today.
          </p>

          <p className="contactAddress">
            <p>Address</p>
            20 Westerham Ave,
            <br /> London, <br /> N9 9BU
          </p>
          <div class="opening-hours">
            <p className="openingHours">Opening Times</p>
            <p>
              <span class="day">Monday:</span>{" "}
              <span class="time">9:30 AM - 5:30 PM</span>
            </p>
            <p>
              <span class="day">Tuesday:</span>{" "}
              <span class="time">9:30 AM - 5:30 PM</span>
            </p>
            <p>
              <span class="day">Wednesday:</span>{" "}
              <span class="time">9:30 AM - 5:30 PM</span>
            </p>
            <p>
              <span class="day">Thursday:</span>{" "}
              <span class="time">9:30 AM - 5:30 PM</span>
            </p>
            <p>
              <span class="day">Friday:</span>{" "}
              <span class="time">9:30 AM - 5:30 PM</span>
            </p>
            <p>
              <span class="day">Saturday:</span>{" "}
              <span class="time">By Appointment Only</span>
            </p>
            <p>
              <span class="day">Sunday:</span> <span class="time">Closed</span>
            </p>
          </div>

          <p>020 8191 0907</p>

          <p>
            <a href="mailto:info@zenhomesldn.com ">info@zenhomesldn.com</a>
          </p>
        
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;
